"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollTo = exports.scrollIntoView = void 0;
var styles_1 = require("../components/navigation/SiteHeader/styles");
var theme_1 = require("../theme");
var scrollIntoView = function (id, align) {
    var element = document.getElementById(id);
    if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: align });
    }
};
exports.scrollIntoView = scrollIntoView;
var scrollTo = function (id) {
    var element = document.getElementById(id);
    if (element) {
        var breakpoint = (0, theme_1.getActiveBreakpoint)();
        var top_1 = element.getBoundingClientRect().top;
        window.scrollTo({
            top: window.scrollY + top_1 - styles_1.HEIGHT[breakpoint],
            behavior: 'smooth',
        });
    }
};
exports.scrollTo = scrollTo;
